import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustCards from './components/TrustCards';
import TasksSolved from './components/TasksSolved';
import WhyFailBeforeMeeting from './components/WhyFailBeforeMeeting';
import AuthorMethodology from './components/AuthorMethodology';
import ProgramIncludes from './components/ProgramIncludes';
import SkillsLearned from './components/SkillsLearned';
import NegotiationTypes from './components/NegotiationTypes';
import WhyProgramsWork from './components/WhyProgramsWork';
import CaseStudy from './components/CaseStudy';
import SuitableAudience from './components/SuitableAudience';
import Formats from './components/Formats';
import HowProjectGoes from './components/HowProjectGoes';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import AboutAuthor from './components/AboutAuthor';
import ReadNextSection from './components/ReadNextSection';

const seoNavLinks = [
  { label: 'Задачи', target: 'tasks' },
  { label: 'Программа', target: 'program' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function NegotiationTrainingSeoPage() {
  return (
    <>
      
      <SeoTitle title="Тренинг по переговорам | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={seoNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <TrustCards />
        <TasksSolved />
        <WhyFailBeforeMeeting />
        <AuthorMethodology />
        <ProgramIncludes />
        <SkillsLearned />
        <NegotiationTypes />
        <WhyProgramsWork />
        <CaseStudy />
        <SuitableAudience />
        <Formats />
        <HowProjectGoes />
        <FAQSection />
        <CTASection />
        <AboutAuthor />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}